
(function(){
  function startCountdown(el){
    var target = new Date(el.getAttribute("data-countdown")).getTime();
    if(!target) return;
    function update(){
      var diff = target - Date.now(); if(diff <= 0) diff = 0;
      var days = Math.floor(diff/(1000*60*60*24));
      var hours = Math.floor((diff/(1000*60*60))%24);
      var minutes = Math.floor((diff/(1000*60))%60);
      var seconds = Math.floor((diff/1000)%60);
      var d=el.querySelector("[data-days]"), h=el.querySelector("[data-hours]"), m=el.querySelector("[data-minutes]"), s=el.querySelector("[data-seconds]");
      if(d)d.textContent=String(days).padStart(2,"0");
      if(h)h.textContent=String(hours).padStart(2,"0");
      if(m)m.textContent=String(minutes).padStart(2,"0");
      if(s)s.textContent=String(seconds).padStart(2,"0");
    }
    update(); setInterval(update,1000);
  }
  document.querySelectorAll("[data-countdown]").forEach(startCountdown);

  var last=0;
  document.addEventListener("mousemove",function(e){
    var now=Date.now(); if(now-last<35)return; last=now;
    var dot=document.createElement("span"); dot.className="dv-glitter";
    dot.style.left=e.clientX+"px"; dot.style.top=e.clientY+"px"; document.body.appendChild(dot);
    setTimeout(function(){dot.remove();},800);
  });
})();
